import React from "react";

interface TableHeaderProps {
  columns: string[];
}

/**
 * テーブルヘッダーコンポーネント
 */
const TableHeader: React.FC<TableHeaderProps> = ({ columns }) => (
  <thead>
    <tr className="h-[30px] bg-[#293D72] font-bold text-white">
      {columns.map((column, index) => (
        <th key={column} className={index ? "text-center w-[124px]" : "pl-8 text-left"}>
          {column}
        </th>
      ))}
    </tr>
  </thead>
);

export default TableHeader;
